import React, { useEffect, useState } from 'react'
import { API_BASE_URL } from '../services/config'
import type { HealthResponse } from '@shared/types'

interface HealthCheckProps {
  className?: string
}

export function HealthCheck({ className = '' }: HealthCheckProps) {
  const [health, setHealth] = useState<HealthResponse | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/health`)
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`)
        }
        const data: HealthResponse = await response.json()
        setHealth(data)
        setError(null)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error')
      } finally {
        setLoading(false)
      }
    }

    checkHealth()
  }, [])

  if (loading) {
    return (
      <div className={`p-4 bg-yellow-100 rounded ${className}`}>
        <p className="text-yellow-800 text-sm">🔄 Checking API health...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className={`p-4 bg-red-100 rounded ${className}`}>
        <p className="text-red-800 text-sm">❌ API health check failed: {error}</p>
      </div>
    )
  }

  return (
    <div className={`p-4 bg-green-100 rounded ${className}`}>
      <p className="text-green-800 text-sm">
        ✅ API is {health?.status} - {health?.service}
      </p>
    </div>
  )
}